import { FC } from 'react'
import { SectionBaseSiteListProps } from '@the-headless-club/models'
import { styled } from '@the-headless-club/styles'
import { Container, SiteCard } from '@the-headless-club/components'
import { useTranslation } from 'react-i18next'

const Wrap = styled('div', {
  background: '$alabaster',
  paddingTop: '$10',
  paddingBottom: '$10',
  '@lg': {
    paddingTop: '$13',
    paddingBottom: '$13',
  },
})
const StyledContainer = styled(Container, {
  background: '$alabaster',
  display: 'grid',
  rowGap: '$11',
  '@md': {
    gridTemplateColumns: '1fr 1fr ',
    columnGap: '$9',
  },
  '@lg': {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
})

const Title = styled('h2', {
  projectFont: 'heading01',
  gridRow: 1,
  gridColumn: '1 / -1',
})

export const SectionBaseSiteList: FC<SectionBaseSiteListProps> = ({
  items,
  hasTitle,
}) => {
  const { t } = useTranslation('site')

  if (!items || items.length === 0) {
    return null
  }

  return (
    <Wrap>
      <StyledContainer>
        {hasTitle && <Title>{t('similarStores')}</Title>}
        {items?.map((item, index) => (
          <SiteCard item={item} key={`${item.name}-${index}`} />
        ))}
      </StyledContainer>
    </Wrap>
  )
}
